var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCsTicket = function SvgCsTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "cs_ticket_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cs_ticket_svg__a)",
    fill: "#404040"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .667a6 6 0 0 0-6 6v4.666c0 1.107.893 2 2 2h2V8H3.333V6.667A4.664 4.664 0 0 1 8 2a4.664 4.664 0 0 1 4.667 4.667V8H10v5.333h2c1.107 0 2-.893 2-2V6.667a6 6 0 0 0-6-6ZM4.667 9.333V12H4a.669.669 0 0 1-.667-.667v-2h1.334Zm8 2c0 .367-.3.667-.667.667h-.667V9.333h1.334v2ZM6 14v.667c0 .366.3.666.667.666h2.666c.367 0 .667-.3.667-.666V14H6Z"
  }))));
};
export default SvgCsTicket;